import React from "react";

// Small pill row for contextual info under a page title (e.g. policy number
// and type on the claim pages). Kept separate from HeaderTitle so pages opt
// in with a plain array of strings (default pill styling) or objects
// ({ label, background, color }) when each tag needs its own colors,
// instead of hand-building markup.
const HeaderTags = ({ tags }: any) => {
  if (!tags || !tags.length) return null;

  return (
    <div className="header-tags">
      {tags.map((tag, index) => {
        const isCustom = tag && typeof tag === "object";
        const label = isCustom ? tag.label : tag;
        const style = isCustom
          ? { background: tag.background, color: tag.color }
          : undefined;

        return (
          <span
            key={label || index}
            className={`header-tag ${(isCustom && tag.className) || ""}`}
            style={style}
          >
            {label}
          </span>
        );
      })}
    </div>
  );
};

export default HeaderTags;
